import { format, parse } from 'date-fns';

/**
 * Converts seconds to hh:mm:ss
 * @param seconds time duration
 * @returns Formatted video string
 */
export const formatDuration = (seconds: number): string => {
  // Return mm:ss if seconds < 3600 (1 hour)
  if (seconds < 3600) {
    return new Date(seconds * 1000).toISOString().slice(14, 19);
  } else {
    return new Date(seconds * 1000).toISOString().slice(11, 19);
  }
};

/**
 * Attempts to cast to JS date. If that fails, assumes
 * date format is the unrecognised dd/mm/yyyy format.
 * If that fails, just return the string as-is. We tried.
 * @param date
 * @returns
 */
export const formatDate = (date: string, includeTime: boolean): string => {
  const stringPattern = includeTime ? 'dd/MM/yyyy - hh:mm a' : 'dd/MM/yyyy';
  try {
    return format(new Date(date), stringPattern);
  } catch (e) {
    console.warn(e);
    try {
      return format(parse(date, stringPattern, new Date()), stringPattern);
    } catch (e) {
      return date;
    }
  }
};

const zoneFormat = new Intl.DateTimeFormat('en-AU', { timeZoneName: 'short' });

/**
 * formatDate(date, true) plus the viewer's timezone abbreviation (e.g. AEDT)
 */
export const formatDateTimeWithZone = (date: string): string => {
  const formatted = formatDate(date, true);
  try {
    const zone = zoneFormat.formatToParts(new Date(date)).find(part => part.type === 'timeZoneName')?.value;
    return zone ? `${formatted} ${zone}` : formatted;
  } catch {
    // formatToParts throws RangeError on an invalid date
    return formatted;
  }
};
